import { render } from "./DiagnosticCard.vue?vue&type=template&id=1e0cfe8d&scoped=true"
import script from "./DiagnosticCard.vue?vue&type=script&lang=js"
export * from "./DiagnosticCard.vue?vue&type=script&lang=js"

import "./DiagnosticCard.vue?vue&type=style&index=0&id=1e0cfe8d&lang=scss&scoped=true"
import "./DiagnosticCard.vue?vue&type=style&index=1&id=1e0cfe8d&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0cfe8d"]])

export default __exports__